import { Layout } from "providers/Layout";
import { RentersHeader } from "views/renters/components/Header";
import { RentersTableWrapper } from "views/renters/components/Table/RentersTableWrapper";
import config from "config/config";
import algoliasearch from "algoliasearch";
import { Configure, InstantSearch } from "react-instantsearch";
import { FiltersDrawer } from "views/renters/components/FilterDrawer";
import { useMemo, useState } from "react";
import { useAuthContext } from "providers/Auth";
import { Link } from "react-router-dom";
import { RowSelectionState } from "@tanstack/react-table";
import { Redirect } from "shared/components/Redirect";
import { PropertyManagementSystem } from "types/landlord/partner";

export const RentersPage = () => {
  const { partner, type } = useAuthContext();

  const [showFilters, setShowFilters] = useState(false);

  const [selectedRentersRow, setSelectedRentersRow] =
    useState<RowSelectionState>({});

  const clearSelectedRows = () => {
    setSelectedRentersRow({});
  };

  const algolia = useMemo(() => {
    if (!config.algoliaAppId || !partner?.algolia?.client_search_key)
      return null;
    else {
      const client = algoliasearch(
        config.algoliaAppId!,
        partner.algolia.client_search_key
      );
      const index = client.initIndex(partner.algolia.index_name!);

      return { client, index };
    }
  }, [config.algoliaAppId, partner?.algolia?.client_search_key]);

  if (
    !type.isPMS ||
    !type.isRentReporting ||
    (partner &&
      partner.property_management_system &&
      partner.property_management_system.name ===
        PropertyManagementSystem.APPFOLIO)
  )
    return <Redirect href="/applications" />;

  if (!partner?.algolia?.client_search_key)
    return (
      <Layout>
        <p>No keys have been provided. Please go to </p>
        <Link to="/settings/developers">developers settings</Link>
      </Layout>
    );

  if (!algolia)
    return (
      <Layout>
        <p>Loading...</p>
      </Layout>
    );

  return (
    <Layout>
      <InstantSearch
        future={{ preserveSharedStateOnUnmount: true }}
        indexName={algolia.index.indexName}
        searchClient={algolia.client}
      >
        <Configure hitsPerPage={10} />
        <RentersHeader
          setShowFilters={setShowFilters}
          selectedRentersRow={selectedRentersRow}
          clearSelectedRows={clearSelectedRows}
        />
        <RentersTableWrapper
          setSelectedRentersRow={setSelectedRentersRow}
          selectedRentersRow={selectedRentersRow}
        />
        <FiltersDrawer
          showFilters={showFilters}
          clearSelectedRows={clearSelectedRows}
          setShowFilters={setShowFilters}
        />
      </InstantSearch>
    </Layout>
  );
};
